module.exports = __webpack_public_path__ + "img/consultation.b60ede48.jpeg";